<template>
	<div class="alert alert-info widget-block period-filter">

		<span>{{ localeFtc('main/from') }}</span>
		<datepicker
			v-model="begin"
			@selected="beginSelected"
			:disabled="disabledForBegin"
			:highlighted="highlightRange"
			format="dd.MM.yyyy"
			:language="$store.state.lang === 'en' ? 'en' : 'ru'"
			wrapper-class="filter-period-wrapper"
			input-class="filter-period-input"			
			:monday-first="true"
			:clear-button="clearBtn"
			name="dateBeginField" />

		<span>{{ localeFtc('main/to') }}</span>
		<datepicker
			v-model="end"
			@selected="endSelected"
			:disabled="disabledForEnd"
			:highlighted="highlightRange"
			format="dd.MM.yyyy"
			:language="$store.state.lang === 'en' ? 'en' : 'ru'"
			wrapper-class="filter-period-wrapper"
			input-class="filter-period-input"
			:monday-first="true"
			:clear-button="clearBtn"
			name="dateEndField" />

		<div class="navigation">
			<span class="navigation-target" @click.stop="setPeriod(1)">{{ labels[$store.state.lang]['today'] }}</span>
			<span class="navigation-target" @click.stop="setPeriod(0)">{{ labels[$store.state.lang]['yesterday'] }}</span>
			<span class="navigation-target" @click.stop="setPeriod(4)">{{ labels[$store.state.lang]['week'] }}</span>
			<span class="navigation-target" @click.stop="setPeriod(2)">{{ labels[$store.state.lang]['month'] }}</span>
			<span class="navigation-target" @click.stop="setPeriod(3)">{{ labels[$store.state.lang]['year'] }}</span>
		</div>
		
		<button v-if="!notClose" class="btn-close-filter close" @click.stop="$emit('closeFilter')">×</button>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Datepicker from 'vuejs-datepicker'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'filterPeriod',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['valueBegin', 'valueEnd', 'clearButton', 'notClose'],
	//=========================================================================
	// локальные изменяемые свойства
	//=========================================================================
	data() {
		return {
			clearBtn: true,
			begin: null,
			end: null,
			disabledForBegin: {
				'from': null
			},
			disabledForEnd: {
				'to': null
			},
			highlightRange: {},
			labels: {
				'ru': {
					'today': 'сегодня',
					'yesterday': 'вчера',
					'week': 'неделя',
					'month': 'месяц',
					'year': 'год'
				},
				'en': {
					'today': 'today',
					'yesterday': 'yesterday',
					'week': 'week',
					'month': 'month',
					'year': 'year'
				}
			}
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Datepicker
	},
	//=========================================================================
	// событие - компонент создан
	//=========================================================================
	created() {
		// если есть указания по поводу кнопку очистки
		if (this.clearButton !== undefined && this.clearButton !== null) this.clearBtn = this.clearButton

		// если задана дата начала
		if (this.valueBegin)
		{
			// установим локальное значение
			this.begin = this.formater_StrDate2Date(this.valueBegin)
		}
		// установим границу
		this.disabledForEnd['to'] = this.begin

		// если задана дата конца
		if (this.valueEnd)
		{
			// установим локальное значение
			this.end = this.formater_StrDate2Date(this.valueEnd)
		}
		// установим границу
		this.disabledForBegin['from'] = this.end

		// если заданы обе даты
		if (this.begin && this.end)
			this.highlightRange = {
				'from': this.begin,
				'to': this.end
			}
		else this.highlightRange = {}
	},
	//=========================================================================
	// наблюдаемые значения
	//=========================================================================
	watch: {
		'valueBegin': function(value) {
			this.updateBegin(value)
		},
		'valueEnd': function(value) {
			this.updateEnd(value)
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// выбрали начало периода
		//---------------------------------------------------------------------
		beginSelected(date) {
			this.begin = date

			// установим границы
			this.disabledForEnd['to'] = this.begin
			// выделение
			if (this.begin && this.end)
				this.highlightRange = {
					'from': this.begin,
					'to': this.end
				}
			else this.highlightRange = {}

			// сообщим родителям что значение поменялось
			this.$emit('input', {
				'begin': this.begin,
				'end': this.end
			})
		},
		//---------------------------------------------------------------------
		// выбрали конец периода
		//---------------------------------------------------------------------
		endSelected(date) {
			this.end = date
			// установим границы
			this.disabledForBegin['from'] = this.end
			// выделение
			if (this.begin && this.end)
				this.highlightRange = {
					'from': this.begin,
					'to': this.end
				}
			else this.highlightRange = {}

			// сообщим родителям что значение поменялось
			this.$emit('input', {
				'begin': this.begin,
				'end': this.end
			})
		},
		//---------------------------------------------------------------------
		// обновление параметра - начала периода
		//---------------------------------------------------------------------
		updateBegin(value) {
			// если задана дата
			if (value)
				this.begin = this.formater_StrDate2Date(value)
			else
				this.begin = null

			// установим границу
			this.disabledForEnd['to'] = this.begin

			// если заданы обе даты
			if (this.begin && this.end)
				this.highlightRange = {
					'from': this.begin,
					'to': this.end
				}
			else this.highlightRange = {}
		},
		//---------------------------------------------------------------------
		// обновление параметра - конец периода
		//---------------------------------------------------------------------
		updateEnd(value) {
			// если задана дата
			if (value)
				this.end = this.formater_StrDate2Date(value)
			else
				this.end = null

			// установим границу
			this.disabledForBegin['from'] = this.end

			// если заданы обе даты
			if (this.begin && this.end)
				this.highlightRange = {
					'from': this.begin,
					'to': this.end
				}
			else this.highlightRange = {}
		},
		//---------------------------------------------------------------------
		// установка периода
		//---------------------------------------------------------------------
		setPeriod(whatPeriod) {
			let d
			let dd

			switch (whatPeriod)	{
			// вчера
			case 0:
				// получаем дату
				d = new Date()
				d.setDate(d.getDate() - 1)
				// обновляем модели
				this.updateBegin(this.formatDate(d))
				this.updateEnd(this.formatDate(d, 'end'))
				// сообщим родителям что значение поменялось
				this.$emit('input', {
					'begin': this.begin,
					'end': this.end
				})
				break
			// сегодня
			case 1:
				// получаем дату
				d = new Date()
				// обновляем модели
				this.updateBegin(this.formatDate(d))
				this.updateEnd(this.formatDate(d, 'end'))
				// сообщим родителям что значение поменялось
				this.$emit('input', {
					'begin': this.begin,
					'end': this.end
				})
				break
			// месяц
			case 2:
				// получаем дату
				d = new Date()
				dd = new Date()
				d.setDate(d.getDate() - 30)
				// обновляем модели
				this.updateBegin(this.formatDate(d))
				this.updateEnd(this.formatDate(dd, 'end'))
				// сообщим родителям что значение поменялось
				this.$emit('input', {
					'begin': this.begin,
					'end': this.end
				})
				break
			// год
			case 3:
				// получаем дату
				d = new Date()
				dd = new Date()
				d.setDate(d.getDate() - 365)
				// обновляем модели
				this.updateBegin(this.formatDate(d))
				this.updateEnd(this.formatDate(dd, 'end'))
				// сообщим родителям что значение поменялось
				this.$emit('input', {
					'begin': this.begin,
					'end': this.end
				})
				break
			// неделя
			case 4:
				// получаем дату
				d = new Date()
				dd = new Date()
				d.setDate(d.getDate() - 7)
				// обновляем модели
				this.updateBegin(this.formatDate(d))
				this.updateEnd(this.formatDate(dd, 'end'))
				// сообщим родителям что значение поменялось
				this.$emit('input', {
					'begin': this.begin,
					'end': this.end
				})
				break
			}
		},
		//---------------------------------------------------------------------
		// форматирование даты
		//---------------------------------------------------------------------
		formatDate(date, what) {
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			let day = date.getDate()

			if (what === 'end')
				return year + '-' +	(month < 10 ? '0' : '') + month + '-' +	(day < 10 ? '0' : '') + day + ' 23:59:59'
			else
				return year + '-' +	(month < 10 ? '0' : '') + month + '-' +	(day < 10 ? '0' : '') + day + ' 00:00:00'
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
div.widget-block > span {
	position: relative;
	top: 1px;	
	margin-bottom: 20px;
}

div.widget-block span:first-child {
    margin-right: 6px;
    margin-left: 0;
}

div.widget-block span {    
    margin: auto 6px;
}

.period-filter {
	padding: 2px 16px 1px 10px;
}

.filter-period-wrapper {
	display: inline-block;
}

.period-filter > .navigation {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: flex-start;
	-webkit-align-items: flex-start;

	font-size: 11px;
    height: 16px;
    margin-top: 2px;
}

.period-filter > .navigation > .navigation-target {
	margin: 0;
    cursor: pointer;
    line-height: 1.1;
    border-bottom: 1px dotted #333;
}

</style>



// WEBPACK FOOTER //
// filterPeriod.vue?eb87dccc